import Component from '../abstracts/Component';

export default class ArticleProductVariantComponent extends Component {
  get SELECTORS() {
    return {
      card: '[data-card]',
      cta: '[data-card-cta]',
      close: '[data-card-close]',
      carousel: '[data-card-carousel]',
    };
  }
  constructor(compEl) {
    super(compEl);
    this.cards = document.querySelectorAll(this.SELECTORS.card);
    this.carousels = document.querySelectorAll(this.SELECTORS.carousel);
  }

  listenCta() {
    this.cards.forEach(card => {
      let cta = card.querySelector(this.SELECTORS.cta);
      let close = card.querySelector(this.SELECTORS.close);
      if (cta) {
        cta.addEventListener('click', () => {
          card.classList.add('show-products');
        });
      }
      if (close) {
        close.addEventListener('click', () => {
          card.classList.remove('show-products');
        });
      }
    });
  }

  listenCard() {
    if (window.matchMedia('(min-width: 992px)').matches) {
      this.cards.forEach(card => {
        card.addEventListener('mouseenter', () => {
          card.classList.add('show-products');
        });
        card.addEventListener('mouseleave', () => {
          card.classList.remove('show-products');
        });
      });
    }
  }

  initCarousels() {
    let options = {
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      swipe: true,
      draggable: true,
      prevArrow: '<button type="button" class="w__slick-prev icon-chevron-left" aria-label="previous slide" data-prev-arrow></button>',
      nextArrow: '<button type="button" class="w__slick-next icon-chevron-right" aria-label="next slide" data-next-arrow></button>',
    };
    this.carousels.forEach(carousel => {
      $(carousel).slick(options);
    });
  }

  importSlick() {
    this.moduleLoader.loadCarouselAndExecute(module => {
        this.initCarousels();
      },
      error => {
        console.error('failed to load slick', error.stack);
      }
    );
  }

  render() {
    this.log('Rendering...');
    if (this.carousels) {
      this.listenCta();
      this.listenCard();
      this.importSlick();
    }
  }
}
